import { type PageProps } from "gatsby";
import { type FC } from "react";
import { LoggedOutBar } from "../../components/AppBar/Bars";
import GuidepostSimplified from "../../components/Rozcestnik/GuidepostSimplified";
import { Seo } from "../../components/SEO";
import { withRedirectWhenLoggedIn } from "../../highOrderComponents/withRedirectWhenLoggedIn";

export const AppBar: FC = () => <LoggedOutBar />;

export const Head: FC = () => (
	<Seo
		description="Vyberte si svůj produkt, na který se chcete podívat."
		title="Rozcestník"
	/>
);

const RozcestnikPage: FC<PageProps> = (pageProps) => {
	return (<GuidepostSimplified pageProps={pageProps} />);
}

export default withRedirectWhenLoggedIn(RozcestnikPage);
